export default function authHeader() {
  const user = JSON.parse(localStorage.getItem("user"));

  if (user && user.data.authToken) {
    return { "x-access-token": user.data.authToken };
  } else return {};
}
